import react from "react";

const About = () => {
    return (
        <div>About me</div>
    );
};

export default About;